import './VersionOptions.scss';

export { default } from './VersionOptions';
